import React from "react";
import { CTAButton } from "../CTAButton";
import { images } from "../../data/links";
import { pillars } from "../../data/content";
export function About() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-71" data-mp="12qwyj0fz1y6d">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[1fr_1.3fr] md:gap-14" data-id="element-72" data-mp="12plxv9htp6jh">
        <img src={images.author} alt="Dr. Michael Carter at his desk" className="mx-auto aspect-square w-full max-w-sm rounded-3xl object-cover object-top md:order-2 md:aspect-[4/5]" loading="lazy" data-id="element-73" data-mp="yptjgg5r0667" />

        <div className="md:order-1" data-id="element-74" data-mp="jrsrtybwkghv">
          <p className="text-sm font-bold uppercase tracking-wide text-gold" data-id="element-75" data-mp="jsufr3e0oxh0">About the author</p>
          <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-76" data-mp="f09lk0r78icy">
            I'm Dr. <em className="text-gold" data-id="element-77" data-mp="3nftcuu8b7qpd">Michael Carter</em>
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/80" data-id="element-78" data-mp="3jg2h0c3xekdz">
            <p data-id="element-79" data-mp="339i51swuq273">
              I created Mastopexy Surgical Blueprint™ after seeing how often professional surgical education becomes
              fragmented. One lecture here. One article there. One operative video somewhere else.
            </p>
            <p data-id="element-80" data-mp="3czjv2q8rluon">
              And eventually, the surgeon is left trying to connect everything into one coherent picture.
            </p>
            <p className="font-semibold text-ink" data-id="element-81" data-mp="2kadyqrwp2mj4">
              I don't believe the solution is always another massive course. Sometimes what you need is a clear framework
              that helps you organize what you already know, identify what you still need to review and practice your
              reasoning through cases.
            </p>
            <p data-id="element-82" data-mp="2z8of6tzumdbk">
              It is not designed to replace formal surgical education, it is not a universal operative protocol, and it
              is not a substitute for supervised training. It is a practical educational system built around:
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-83" data-mp="2ak14hkchlsrv">
            {pillars.map(p => <li key={p} className="rounded-full bg-navy px-4 py-2 text-sm font-bold text-white" data-id="element-84" data-mp="25lpu98ia5g94">
                {p}
              </li>)}
          </ul>

          <p className="mt-6 text-[17px] leading-relaxed text-ink/80" data-id="element-85" data-mp="2jj4oqrne4e7y">
            My goal is simple: help you study mastopexy in a more organized and repeatable way.
          </p>
          <p className="mt-3 font-serif text-2xl italic text-navy" data-id="element-86" data-mp="1rukpxt3yvzsg">— Dr. Michael Carter</p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-5xl" data-id="element-87" data-mp="1msvguj0b1w70">
        <CTAButton label="I want to study mastopexy the organized way" data-id="element-88" data-mp="20mmotmye180m" />
      </div>
    </section>;
}